export default "__VITE_ASSET__BLWJ_YrS__"